import { render, staticRenderFns } from "./DeliveryService.vue?vue&type=template&id=606b471c&scoped=true"
import script from "./DeliveryService.vue?vue&type=script&lang=js"
export * from "./DeliveryService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b471c",
  null
  
)

export default component.exports